/**
 * Axios HTTP client configured for the Atal Cloud CTI API.
 * JWT token injection placeholder for Cognito auth (Milestone 11).
 */

import axios from 'axios';
import config from '../config/app.config';

const apiClient = axios.create({
  baseURL: config.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Request interceptor — inject JWT from Cognito session
apiClient.interceptors.request.use(
  (requestConfig) => {
    const token = localStorage.getItem('ppcti_id_token');
    if (token) {
      requestConfig.headers.Authorization = token;
    }
    return requestConfig;
  },
  (error) => Promise.reject(error)
);

// Response interceptor — handle 401 by clearing the stale session, then
// redirecting to login. Clearing FIRST is essential: otherwise the stored
// session still looks authenticated, /login bounces back to /, the next API
// call 401s again, and the app flashes/loops forever.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('ppcti_user');
      localStorage.removeItem('ppcti_id_token');
      localStorage.removeItem('ppcti_access_token');
      // Avoid redirect loop if we're already on the login page.
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
